
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { getPortfolioTypeIcon } from '@/utils/portfolioUtils';
import { Portfolio } from '@/types/portfolio';
import { usePersonaBasePath } from '@/utils/headerUtils';

interface PortfolioHeaderProps {
  portfolio: Portfolio;
}

export const PortfolioHeader = ({ portfolio }: PortfolioHeaderProps) => {
  const basePath = usePersonaBasePath();
  
  return (
    <div className="mb-8">
      <div className="flex items-center gap-2 text-muted-foreground mb-2">
        <Link to={basePath} className="hover:underline">Portfolios</Link>
        <ArrowRight className="h-4 w-4" />
        <span>{portfolio.title}</span>
      </div>
      
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <div>
          <div className="flex items-center gap-2 mb-2">
            <h1 className="text-3xl font-bold">{portfolio.title}</h1>
            <Badge variant={portfolio.status === 'active' ? 'default' : 'outline'}>
              {portfolio.status}
            </Badge>
          </div>
          <div className="flex items-center text-muted-foreground">
            {getPortfolioTypeIcon(portfolio.portfolio_type)}
            <span className="capitalize">{portfolio.portfolio_type.replace('_', ' ')}</span>
          </div>
        </div>
      </div>
      
      {portfolio.description && (
        <p className="text-muted-foreground mb-8">{portfolio.description}</p>
      )}
    </div>
  );
};
